import {Injectable} from '@angular/core';
import {
    MeasureValuePolarContainer,
    RadarPolarMeasureValue,
    RainNode,
    RainPolarMeasureValue,
} from 'raain-model';
import {PolarMapValue} from 'raain-ui';
import {ProfileService} from './profile.service';
import {FrameSet} from './tools';

@Injectable()
export class RadarService {
    constructor(private profileService: ProfileService) {}

    static getGeoValuesFromRainMeasures(
        measureValue: RainPolarMeasureValue,
        rain: RainNode
    ): PolarMapValue[] {
        return this.computeValues(measureValue.getPolars(), rain);
    }

    static getGeoValuesFromRadarMeasures(
        measureValue: RadarPolarMeasureValue,
        rain: RainNode
    ): PolarMapValue[] {
        return this.computeValues(measureValue.getPolars(), rain);
    }

    private static computeValues(polarMeasureValues: MeasureValuePolarContainer[], rain: RainNode) {
        const values: PolarMapValue[] = [];
        polarMeasureValues.forEach((p) => {
            const azimuth = p.azimuth;
            let distance = 0;
            const polarEdges = p.polarEdges;
            polarEdges.forEach((e) => {
                const pmv = new PolarMapValue(e, azimuth, distance);
                values.push(pmv);
                distance += p.distance;
            });
        });

        return values;
    }

    async getTimeline(rainNode: RainNode): Promise<FrameSet[]> {
        const timeline: FrameSet[] = [];
        const links = rainNode?.getLinks() ?? [];

        for (const link of links) {
            const cumulativeIndex = link.href.indexOf('cumulatives/');
            if (cumulativeIndex >= 0) {
                const start = cumulativeIndex + 'cumulatives/'.length;
                const str1 = link.href.substring(start);
                if (str1) {
                    const splitted = str1.split('/');
                    const frameDate = new Date(splitted[0]);
                    const version = splitted[1];
                    const rainComputationCumulativeId = splitted[2];
                    const existingTargets = timeline.filter(
                        (t) => t.date.getTime() === frameDate.getTime()
                    );
                    if (existingTargets.length) {
                        existingTargets[0].rainComputationCumulativeId =
                            rainComputationCumulativeId;
                    } else {
                        timeline.push(
                            new FrameSet(frameDate, [], null, null, [], rainComputationCumulativeId)
                        );
                    }
                }
            }
        }

        return timeline;
    }
}
